// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"PageNav--next-sr-only--1Sc8eBI","douStoreNav":"PageNav--douStoreNav--14XWjCx"};